import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../redux/actions";
import logoVector from "../../resources/image/vector_profile.jpg";
import Loading from "../util/page-loading";
import {logout_from_account, logout_from_account_description} from "../../resources/string/strings";
import ModalLogout from "../util/modal-yes-or-no";
import {  terminateSession } from "../../network/api";
import { logout, getSessionKeyId } from "../../authentication/authorizer";

class Profile extends Component {
  state = {
    pageTitle: "پروفایل",
    pageTag: "profile",
    logoutModalShow: false,
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle);
    document.title = this.state.pageTitle;
  }

  render() {
    var profile = this.props.profile.profile
    return (
      <div className="mx-auto fragment text-center">

        {(profile === undefined || profile === null || profile === {} || profile.username === undefined) && <Loading/> }

        {profile !== undefined ** profile !== null && profile !== {} && profile.username !== undefined &&
           <div className="app-card mx-auto mb-5" >
          <img
            className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            src={logoVector}
            alt=""
          />

          <div style={{ fontSize: 14, color: "dimgray" }}>پروفایل کاربری</div>

          <div className="mt-3" style={{fontSize: 16, color: "black" }}>
            {profile.username}
          </div>

          <div className="mt-1 mb-3" style={{fontSize: 12, color: "gray" }}>
            {profile.role}
          </div>

        <button  onClick={this.showLogoutModal} button className="btn btn-danger mb-3">{logout_from_account}</button>

        </div>
      }

        <ModalLogout
          show={this.state.logoutModalShow}
          onHide={this.handleLogoutModalClose}
          title={logout_from_account}
          description={logout_from_account_description}
        />
      </div>
    );
  }

  showLogoutModal = () => {
    this.setState({ logoutModalShow: true });
  };

  handleLogoutModalClose = (isYes) => {
    this.setState({ logoutModalShow: false });
    if (isYes) {
      this.handleLogoutClick();
    }
  };

  handleLogoutClick = () => {
    this.callTerminateSessionApi()
  };

  /****
  ** NETWORK
  *****/

  callTerminateSessionApi = () => {
    terminateSession(getSessionKeyId(), this.handleTerminateSessionApiSuccess, this.handleTerminateSessionFailure);
  };

  handleTerminateSessionApiSuccess = (data) => {
    logout();
    window.location.reload();
  };

  handleTerminateSessionFailure = (error) => {
    logout();
    window.location.reload();
  };
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Profile);
